export class CommonHelper {
  public static arrayChunk(inputArray: any[], size = 10): any[] {
    return inputArray.reduce((resultArray, item, index) => {
      const chunkIndex = Math.floor(index / size);

      if (!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = []; // start a new chunk
      }
      resultArray[chunkIndex].push(item);

      return resultArray;
    }, []);
  }
}
